import { render, staticRenderFns } from "./BodyParts.vue?vue&type=template&id=66f43001&scoped=true&"
import script from "./BodyParts.vue?vue&type=script&lang=js&"
export * from "./BodyParts.vue?vue&type=script&lang=js&"
import style0 from "./BodyParts.vue?vue&type=style&index=0&id=66f43001&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f43001",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/BodyParts.vue
// module id = null
// module chunks = 